<div class="container">
    <div class="row">
        <div
            class="col-sm d-flex text-center text-md-left justify-content-center justify-content-md-start"
        >
            <a
                href="//www.poettinger.at/{{
                    this.countryCode$ | async
                }}/Home/Impressum"
                target="_new"
                >{{ "legal_notice" | translate }}
            </a>
            |
            <a
                href="//www.poettinger.at/{{
                    this.countryCode$ | async
                }}/dataprotection/mypoettinger"
                target="_new"
                >{{ "Datenschutz" | translate }}
            </a>
            | <a routerLink="/contact">{{ "contact" | translate }} </a> |
            <button type="button" class="footer-link-button" (click)="openCookieSettings()">
                Cookies
            </button>
        </div>
        <div class="col-sm d-none d-md-flex copyright">
            © {{ anio }} PÖTTINGER Landtechnik GmbH
        </div>
    </div>
</div>
